import React, { useState } from "react";
import {
    EuiFormRow,
    EuiFlexGroup,
    EuiFlexItem,
    EuiCheckbox,
    EuiSpacer,
    EuiFieldText,
    EuiText,
} from "@elastic/eui";
import ReactMapboxGl, { Layer, Feature } from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import googlePin from "../../../../../assets/images/google_maps_pin_24.png";
import Spinner from "../../../../../components/Spinner";

function CurrentLocation({ latitude, longitude, error, cityName, onUsingCurrentLocation }) {
    const [isChecked, setIsChecked] = useState(false);

    const currentLocationUsage = (e) => {
        setIsChecked(e.target.checked);
        onUsingCurrentLocation(e.target.checked);
    };

    const Map = ReactMapboxGl({
        accessToken:
            "pk.eyJ1IjoiZGVhZGxvY2siLCJhIjoiY2o4b25pY3dqMDU5bjJ3cWNoNWMzZ2QwciJ9.bsjPa7Or0YmYeXXI1EHFUA",
    });

    const MarkerImage = new Image();
    MarkerImage.src = googlePin;

    const defaultLongitude = 31.28701;
    const defaultLatitude = 30.08885;

    return latitude && longitude ? (
        <EuiFlexGroup direction="column">
            <EuiSpacer />
            <EuiFlexItem>
                <EuiFormRow
                    fullWidth
                    label="City"
                    key="cityId"
                >
                    <EuiFieldText
                        disabled
                        fullWidth
                        name="cityId"
                        value={cityName}
                    />
                </EuiFormRow>
            </EuiFlexItem>
            <EuiSpacer />
            <EuiFlexItem style={{ height: 300 }}>
                <Map
                    animationOptions={{
                        animate: true,
                    }}
                    style="mapbox://styles/mapbox/streets-v9"
                    center={[longitude || defaultLongitude, latitude || defaultLatitude]}
                    zoom={[14]}
                    containerStyle={{
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Layer
                        type="symbol"
                        id="marker"
                        layout={{ "icon-image": "google-pin" }}
                        images={["google-pin", MarkerImage]}
                    >
                        <Feature coordinates={[longitude, latitude]} />
                    </Layer>
                </Map>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiFormRow>
                    <EuiCheckbox
                        disabled={!(latitude && longitude)}
                        label="Use Current Location"
                        checked={isChecked}
                        onChange={(e) => currentLocationUsage(e)}
                    />
                </EuiFormRow>
            </EuiFlexItem>
        </EuiFlexGroup>
    ) : error ? (
        <EuiText
            color="danger"
            textAlign="center"
        >
            Could not fetch current location. Please Allow location access
        </EuiText>
    ) : (
        <Spinner />
    );
}

export default CurrentLocation;
